<template>
  <footer class="container footer footer-ds">
    <div class="row">
      <div class="col-md-3">

      </div>
      <div class="col-md-6">
        <p class="mb-md-0 mb-0">We are dedicated to protecting your private information. </p>
        <a role="button" style="color:#ffffff" class="footer__link" @click="nextRoute('protection')">Click here to learn more about information protection</a>
      </div>
      <div class="col-md-3">
        <a role="button" class="footer__link">Help and Support</a>
        <a role="button" class="footer__link" @click="nextRoute('terms')">Terms & Conditions</a>
        <a role="button" class="footer__link" @click="nextRoute('privacy-policy')" >Privacy Policy</a>
        <!-- The running builds and the environment, for bug reports
             (abquRFhf), with a flag when the FE and the API are not the same
             build. This footer is the private layout's, so it renders only
             after sign-in. -->
        <span class="footer__build" data-test="build-stamp">FE {{ frontendBuildLabel }}<template v-if="apiBuildLabel"> · API {{ apiBuildLabel }}</template><template v-if="environment"> · {{ environment }}</template></span>
        <span v-if="buildMismatch" class="footer__build footer__build--mismatch" data-test="build-mismatch">FE and API builds differ</span>
      </div>
    </div>
  </footer>
</template>

<script>
import router from '@/router/index';
import { useSessionStore } from "@/stores/session";
import { buildsDiffer, describeBuild, environmentName, frontendBuild } from "@/utils/buildInfo";
  export default {
    name: "FooterBar",
    computed: {
      frontendBuildLabel() {
        return describeBuild(frontendBuild());
      },
      /**
       * The API's build from GET /me; empty until it answers. Read from the
       * store inside the computed, so the API's half appears the moment the
       * session store's `me` is set.
       */
      apiBuildLabel() {
        const me = useSessionStore().me;

        return me && me.build ? describeBuild(me.build) : "";
      },
      /** The deployment's name, as the navigation bar's badge reads it. */
      environment() {
        return environmentName();
      },
      buildMismatch() {
        const me = useSessionStore().me;

        return buildsDiffer(frontendBuild(), me && me.build ? me.build : null);
      },
    },
    methods: {
      nextRoute(route){
        router.push(`/${route}`)
      }
    }
  }
</script>

<style scoped lang="scss">
  $color-base: #24555b; /* deep teal — solid, no fade */

  .footer {
    max-width: 100%;
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
    background-color: $color-base;
    color: #fff;
    font-size: 0.8rem;
    text-align: center;
    font-family: "Inter", system-ui, sans-serif;
    
    /* Small but readable, lower right, as the card asks. */
    .footer__build {
      display: block;
      margin-top: 0.5rem;
      font-size: 0.7rem;
      opacity: 0.85;
      text-align: right;
    }

    .footer__build--mismatch {
      margin-top: 0;
      font-weight: 600;
      opacity: 1;
    }

    .footer__link {
      display: block;
      color: #ffffff;
      &:hover {
        text-decoration: underline;
        cursor: pointer;
      }
    }
    position: absolute;
    bottom: 0;
  }

</style>